import { render, staticRenderFns } from "./DashboardWidgetMessagesNew.vue?vue&type=template&id=036b57f0&scoped=true&lang=pug&"
import script from "./DashboardWidgetMessagesNew.vue?vue&type=script&lang=js&"
export * from "./DashboardWidgetMessagesNew.vue?vue&type=script&lang=js&"
import style0 from "./DashboardWidgetMessagesNew.vue?vue&type=style&index=0&id=036b57f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036b57f0",
  null
  
)

/* custom blocks */
import block0 from "./DashboardWidgetMessagesNew.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports